import React, { useState } from "react";
import ReactModal from "react-modal";
import FormattedMessage from "components/FormattedMessage";
import { Box, Flex, Text, Label } from "ui-components";
import CheckboxField from "components/FormFields/CheckboxField";
// import PDFViewr from "components/PDFViewer";
import { isMobile } from "utils/helpers";
import { useLoadingSpinner } from "hooks";
const PDFViewr = React.lazy(() => import("components/PDFViewer"));

const CriticalInfoModal = props => {
  const {
    id,
    field,
    isOpen,
    closeModal,
    details = "details",
    critical_info = "critical_info",
    mandatory_read_message = "mandatory_read_message",
    themeColors,
    pdfViewerData = {},
    iframe = false
  } = props;
  const manadatoryReadsEnabled = !!props.mandatory_read_message;

  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  // If manadatory read is enabled then we show a loader unil the read is ready. Only then the acknowledge checkbox will be available
  const [iFrameLoading, setIFrameLoading] = useState(manadatoryReadsEnabled);
  const { LoadingSpinner } = useLoadingSpinner();

  /**
   * If user provides the consent, close the popup after a delay
   * The delay is to provide a window to the user to see the selection
   * @param {HTMLInputElement} param
   */
  const onAcknowledgementSelect = ({ target }) => {
    if (target.checked) setTimeout(closeModal, 500);
  };

  const modalContentHeight = isMobile() ? "87%" : "92%";

  const scrollToBottomCheck = event => {
    // Not worrying about iFrame right now
    if (iframe) return;
    const { scrollHeight, scrollTop, clientHeight } = event.target;
    const margin = 100;
    const bottomReached = scrollHeight - scrollTop < clientHeight + margin;

    // debug log to check the function in different browser versions
    console.debug("scrollToBottomCheck", {
      scrollHeight,
      scrollTop,
      clientHeight,
      rest: event.target
    });

    if (bottomReached) {
      setScrolledToBottom(true);
    }
  };

  const onIFrameLoad = () => {
    setIFrameLoading(false);
  };

  const onIFrameError = e => {
    setIFrameLoading(false);
    console.error("CriticalInfoModal: onIFrameError", e);
  };

  return (
    <ReactModal isOpen={isOpen} style={modalStyle}>
      <Flex pb={2} onClick={closeModal} sx={{ cursor: "pointer" }}>
        <Text pr={2}>X</Text>
        <FormattedMessage id="close" />
      </Flex>
      <Box
        p={4}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          height: modalContentHeight
        }}
        onScroll={scrollToBottomCheck}
      >
        {iframe ? (
          <FormattedMessage html id={details}>
            {messageContent => (
              <>
                {iFrameLoading && <LoadingSpinner />}
                <iframe
                  src={messageContent}
                  title={critical_info}
                  style={{ height: "100%", width: "100%" }}
                  onLoad={onIFrameLoad}
                  onError={onIFrameError}
                ></iframe>
              </>
            )}
          </FormattedMessage>
        ) : (
          <FormattedMessage html id={details}>
            {messageContent => (
              <React.Suspense fallback={<LoadingSpinner />}>
                <PDFViewr pdfUrl={messageContent} {...pdfViewerData} />
              </React.Suspense>
            )}
          </FormattedMessage>
        )}
      </Box>
      {iframe && (
        <Flex mt={4} pb={5}>
          <Box mr={2}>
            <Label>
              <CheckboxField
                id={id}
                field={field}
                label=""
                onChange={onAcknowledgementSelect}
                checkBoxOnly
                themeColors={themeColors}
              />
            </Label>
          </Box>
          <Box sx={{ fontWeight: "normal" }} pl={2}>
            <FormattedMessage html id={critical_info} />
          </Box>
        </Flex>
      )}

      {!iframe && (
        <Flex mt={4} pb={5}>
          {scrolledToBottom && (
            <Box mr={2}>
              <Label>
                <CheckboxField
                  id={id}
                  field={field}
                  label=""
                  onChange={onAcknowledgementSelect}
                  checkBoxOnly
                  themeColors={themeColors}
                />
              </Label>
            </Box>
          )}
          <Box sx={{ fontWeight: "normal" }} pl={2}>
            {scrolledToBottom ? (
              <FormattedMessage html id={critical_info} />
            ) : (
              <FormattedMessage html id={mandatory_read_message} />
            )}
          </Box>
        </Flex>
      )}
    </ReactModal>
  );
};

const modalStyle = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    zIndex: 2000
  },
  content: {
    top: "0.5rem",
    left: "0.25rem",
    right: "0.25rem",
    bottom: "0.5rem",
    position: "fixed",
    border: "1px solid #ccc",
    background: "rgb(210 210 210)",
    overflow: "auto",
    borderRadius: "8px",
    outline: "none",
    padding: "10px",
    margin: "auto",
    inset: "0.5rem"
  }
};

export default CriticalInfoModal;
